module.exports = __webpack_public_path__ + "img/logo-2.1bccb4f8.svg";